import React, { useContext, useEffect, useState } from 'react';
import { fromJS } from 'immutable';
import { useParams, useNavigate } from 'react-router-dom';
import * as ActionTypes from '../../../constants/action-types';
import { EntitiesContext } from '../../../App';
import { usePollOrder } from '../../../hooks/useOrder';
import { useGetSaleOrders } from '../../../hooks/useSale';

import Checkout from './Checkout';
import Scan from './Scan';
import Search from './Search';
import Custom from './Custom';

const id = 'id';
const scan = 'scan';
const credit = 'CREDIT_CARD';
const cash = 'CASH';

export default function Order() {
  const navigate = useNavigate();
  const entities = useContext(EntitiesContext);
  const lists = entities.state.get('list');
  const sale = entities.state.get('sale').find(s => s.open);
  const [search, setSearch] = useState(null);
  const [order, setOrder] = useState(fromJS([]));
  const [paymentMethod, setPaymentMethod] = useState('CREDIT_CARD');

  const [refetchId, setRefetchId] = useState(null);
  const [refetchInterval, setRefetchInterval] = useState(2000);

  const [vendorId, setVendorId] = useState(null);

  useGetSaleOrders(sale.id);

  // in order to know that the order has been paid, and reset the view
  // start fetching the placed order when `refetchId` has a value
  // if its' status updates to `paid` turn off the query and stop the polling
  // all logic handled in the custom hook/useQuery
  const placedOrder = usePollOrder(refetchId, refetchInterval, data => {
    if (data.data?.data?.data?.attributes?.status === 'paid') setRefetchId(null);
  });

  // reset state when unmounting
  useEffect(() => {
    // always clear out inventory in state when starting new order
    entities.dispatch({
      type: ActionTypes.CLEAR_ENTITIES,
      payload: 'inventory'
    });

    return function cleanup() {
      setOrder([]);
      setPaymentMethod(credit);
      entities.dispatch({
        type: ActionTypes.CLEAR_ENTITIES,
        payload: 'inventory'
      });
      entities.dispatch({
        type: ActionTypes.CLEAR_ENTITIES,
        payload: 'order'
      });
    }
  }, []);

  // check the placed order status and redirect back to admin when it's paid
  // the navigation router triggers unmount cleanup
  useEffect(() => {
    if (placedOrder.data?.data?.data?.attributes?.status === 'paid') {
      navigate('/admin');
    }
  }, [placedOrder]);

  return (<>
    <Scan
      scan={scan}
      search={search}
      setSearch={setSearch}
    />

    {search === id && <Search
      setSearch={setSearch}
      setVendorId={setVendorId}
    />}

    <Custom
      vendorId={vendorId}
      setVendorId={setVendorId}
    />

    <Checkout
      id={id}
      credit={credit}
      cash={cash}
      scan={scan}
      search={search}
      setSearch={setSearch}
      paymentMethod={paymentMethod}
      setPaymentMethod={setPaymentMethod}
      setRefetchId={setRefetchId}
      sale={sale}
    />
  </>);
}
